import React from 'react'
import { useHistory } from 'react-router'
import { DocumentText } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import { Routes } from '@SonarCX/Routes'
import { FavoriteCardProps } from '..'
import { fetchArticle, selectArticles } from '@SonarCX/slices/article'

import FavoriteButton from '@SonarCX/components/atoms/FavoriteButton'
import Tooltip from '@SonarCX/components/atoms/Tooltip'
import DraggableContainer from '../DraggableContainer'

import useStyles from '../styles'

const FavoriteArticle: React.FC<FavoriteCardProps> = ({
  favorite,
  searchValue,
  draggable,
  handleMoveFavorite
}) => {
  const theme = useTheme()
  const classes = useStyles({})
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { articles } = useAppSelector(selectArticles)
  const fullArticle = React.useMemo(
    () => articles[favorite.item_id] ?? null,
    [articles, favorite]
  )
  const navigate = () => {
    history.push(`${Routes.DOCUMENTS}/${favorite.item_id}`)
  }
  // Gets the full tasks
  React.useEffect(() => {
    if (fullArticle) {
      return
    }
    dispatch(fetchArticle(favorite.item_id))
  }, [favorite, fullArticle, dispatch])

  if (!fullArticle) return null

  if (
    searchValue.length > 0 &&
    !fullArticle.title.toLowerCase().includes(searchValue.toLowerCase())
  )
    return null

  return (
    <DraggableContainer
      favorite={favorite}
      draggable={draggable}
      handleMoveFavorite={handleMoveFavorite}
    >
      <div onClick={navigate}>
        <span className={classes.info}>
          <FavoriteButton
            isFavorite
            type={favorite.type}
            itemId={favorite.item_id}
          />

          <Tooltip title='Article'>
            <DocumentText
              size={theme.size.base}
              variant='Bulk'
              color={theme.palette.primary.main}
            />
          </Tooltip>

          <span className={classes.title}> {fullArticle.title}</span>
        </span>
      </div>
    </DraggableContainer>
  )
}

export default FavoriteArticle
